import React, { useEffect } from 'react';
import { Link } from "react-router";
import { analytics } from '../../services/analytics';
import styles from './NotFound.module.scss';

const NotFound: React.FC = () => {
  const trackedRef = React.useRef(false);
  useEffect(() => {
    if (trackedRef.current) return; // StrictMode double-invoke guard
    trackedRef.current = true;
    // Doubles as the route ErrorBoundary, so this also captures pages that
    // failed to load (bad product URLs, loader errors).
    analytics.track('not_found_viewed', {
      path: window.location.pathname + window.location.search,
    });
  }, []);

  return (
    <div className={styles.notFound}>
      <div className={styles.content}>
        <h1 className={styles.title}>404</h1>
        <h2 className={styles.subtitle}>Page Not Found</h2>
        <p className={styles.message}>
          Oops! The page you're looking for doesn't exist or has been moved.
        </p>
        <Link to="/" className={styles.homeButton}>
          Go Back to OnePlay Store
        </Link>
      </div>
    </div>
  );
};

export default NotFound; 